<template>
  <span>
    <Dialog class="test-box" header="Exportar Notas Fiscais Maior Período" :visible.sync="showExportarNfsePeriodo"
      :contentStyle="{ overflow: 'visible', width: '1000px', height: '650px' }" :modal="true" :closable="false">
      <div id="topo" class="row" style="margin-right: 380px;">
        <div class="col-md-4 col-lg-6 mb-3">
          <span class="p-fluid">
            <CustomCalendar id="dataIni" name="dataIni" v-model="dataFatoGeradorIni" :showIcon="true" dateFormat="dd/mm/yy"
              placeholder="Período Inicial*" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
          </span>
        </div>
        <div class="col-md-4 col-lg-6 mb-3">
          <span class="p-fluid">
            <CustomCalendar id="dataFin" name="dataFin" v-model="dataFatoGeradorFim" :showIcon="true" dateFormat="dd/mm/yy"
              placeholder="Período Final*" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-6 mb-3">
          <span class="p-fluid">
            <AutoComplete id="tomador" v-model="selectedPessoa" :dropdown="true" :suggestions="filteredPessoas"
              @complete="searchPessoa($event)" @keyup.enter="pesquisar" field="detail"
              :placeholder="placeholderPessoa" style="width: 40vw; margin-right: 138px;" />
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-12 mb-3">
          <span class="p-fluid">
            <AutoComplete id="servico" v-model="selectedServico" :dropdown="true" :suggestions="filteredServicos"
              field="detail" @complete="searchServico($event)" placeholder="Pesquisar Serviço"
              style="width: 40vw; margin-right: 138px;">
              <template #item="slotProps">
                <div class="p-fluid" style="max-width: 50vw">
                  {{ slotProps.item.detail }}
                </div>
              </template>
            </AutoComplete>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-lg-4 mb-3">
          <span class="p-fluid">
            <Dropdown id="situacao" v-model="filtroSituacao" :options="filtroSituacoes" optionLabel="name"
              placeholder="Selecione uma Situação" />
          </span>
        </div>
        <div class="col-md-4 col-lg-4 mb-3">
          <span class="p-fluid">
            <Dropdown 
              id="tipo" 
              v-model="filtroTipo" 
              :options="tiposFiltrados" 
              optionLabel="name"
              placeholder="Selecione um Tipo" 
            />
          </span>
        </div>
      </div>

      <Toast style="width: 700px;" position="bottom-center" group="bc">
        <template #message="slotProps">
          <div class="flex flex-column">
            <div class="text-center">
              <i class="pi pi-info-circle" style="font-size: 3rem"></i>
              <h4 style="font-weight: bold">{{ slotProps.message.summary }}</h4>
              <p class="msg-export">{{ slotProps.message.detail }}</p>
              <p class="msg-export">
                Assim que a exportação for finalizada, você receberá um e-mail de confirmação.
              </p>
            </div>
          </div>
        </template>
      </Toast>

      <TabView>
        <TabPanel :header="tituloModel">
          <DataTable style="min-width: 880px" :value="exportsList" :paginator="true" :rows="4"
            class="p-datatable-responsive" :autoLayout="true">
            <Column headerStyle="width: 12em" bodyStyle="text-align: center" header="Exportação">
              <template #body="slotProps">
                <Button :disabled="slotProps.data.status !== 'Concluído'|| loading" type="button" icon="pi pi-download"
                  style="margin-right: .5em"
                  @click="downloadExportacao(slotProps.data.id, slotProps.data.tipo, slotProps.data.dataInicial, slotProps.data.dataFinal)" >
                </Button>
              </template>
            </Column>
            <Column bodyStyle="text-align: center" field="dataSolicitacaoFormatada" header="Data Solicitação"></Column>
            <Column bodyStyle="text-align: center" field="periodoInicialFormatado" header="Período Inicial"></Column>
            <Column bodyStyle="text-align: center" field="periodoFinalFormatado" header="Período Final"></Column>
            <Column bodyStyle="text-align: center" field="tipoFormatado" header="Tipo Exportação"></Column>
            <Column bodyStyle="text-align: center" field="status" header="Status"></Column>
          </DataTable>
        </TabPanel>
      </TabView>
      <div class="container" style="margin-top: 5px;">
        <div class="row container-button">
          <div class="box-button">
            <div>
              <Button v-if="origem === 'NFSE'"
                @click="showExportarNfsePeriodo = false" 
                type="button" 
                label="Voltar"
                class="p-button-secondary mr-2" 
                icon="pi pi-angle-left" 
              />

              <Button v-if="origem === 'DAPS'"
                @click="showExportarNfsePeriodo = false" 
                type="button" 
                label="Fechar"
                class="p-button-danger mr-2" 
                icon="pi pi-times" 
              />
            </div>
            <div>
              <Button @click="solicitarExportacao(false)" href="#topo" type="button" label="Exportar Notas"
                class="p-button-primary mr-2 p-button-success" icon="pi pi-upload" :disabled="loading" />
            </div>
          </div>
          <div v-if="admin && origem === 'NFSE'" class="box-button">
            <div>
              <Button 
                @click="solicitarExportacao(true)" 
                href="#topo" 
                type="button" 
                label="Exportação Geral"
                class="p-button-primary mr-2" 
                icon="pi pi-upload" 
                :disabled="loading" 
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
import { maska } from 'maska'
import ContribuinteServicoService from "@/services/tributario/contribuinte.servico.service";
import NotaFiscalService from "@/services/nfse/notafiscal.service";
import PessoaService from "@/services/nfse/pessoa.service";
import LoginService from "@/services/acesso/login.service";
import ReportService from "@/services/report.service";
import CustomCalendar from "@/components/global/CustomCalendar.vue";

export default {
  directives: { maska },
  name: "ExportarNfseMaiorPeriodo",
  components: {CustomCalendar },
  props:{
    origem: {
      type: String,
      default: 'NFSE'
    }
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.notaAvulsa = this.currentUser.emiteNotaAvulsa;
    this.admin = this.currentUser.usuario.idBolAdmin;

    this.consultaSolicitacoes();

    this.$root.$on("notaFiscal:exportarMaiorPeriodo", () => {
      this.showExportarNfsePeriodo = true;
      this.dataFatoGeradorIni = null;
      this.dataFatoGeradorFim = null;
      this.selectedPessoa = null;
      this.filteredPessoas = null;
      this.selectedServico = null;
      this.filteredServicos = null;

      this.filtroTipo = this.tiposFiltrados[0];
    });

  },

  data() {
    return {
      loading: false,
      showExportarNfsePeriodo: false,
      currentUser: null,
      dataFatoGeradorIni: null,
      dataFatoGeradorFim: null,
      selectedPessoa: null,
      filteredPessoas: null,
      selectedServico: null,
      filteredServicos: null,
      notaAvulsa: null,
      filtroSituacao: "",
      filtroSituacoes: [
        { name: "Todos", key: "T" },
        { name: "Ativa", key: "A" },
        { name: "Cancelada", key: "C" },
        { name: "Substituida", key: "S" }
      ],
      filtroTipo: "",
      filtroTipos: [
        { name: "XML", key: "X" },
        { name: "XLS", key: "E" },
        { name: "PDF", key: "P" }
      ],
      exportsList: [],
      admin: false
    };
  },

  methods: {
    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoas = await PessoaService.findAllByConttribuinteFiltro(
          event.query,
          ""
        );
      }, 550);
    },
    searchServico(event) {
      if (this.currentUser.configuracao.idBolHabilitaCnaeNf == "N") {
        if (this.notaAvulsa) {
          // Se for nota avulsa exibir todos os serviços
          setTimeout(async () => {
            this.filteredServicos =
              await ContribuinteServicoService.findAllNfAvulsa(
                event.query,
                this.currentUser.contribuinte.idContribuinte
              );
          }, 250);
        } else {
          setTimeout(async () => {
            this.filteredServicos =
              await ContribuinteServicoService.findAllServicosByContribuinteFiltro(
                event.query,
                this.currentUser.contribuinte.idContribuinte
              );
          }, 250);
        }
      }
    },
    consultaSolicitacoes() {
      const idContribuinte = this.currentUser.contribuinte.idContribuinte;
      this.processando(true);
      if (this.origem === 'DAPS') {
        NotaFiscalService.findSolicitExportDaps(idContribuinte)
          .then((data) => {
            this.exportsList = data.data;
          })
          .finally(() => this.processando(false));
      } else {
        NotaFiscalService.findSolicitExportNfse(idContribuinte)
          .then((data) => {
            this.exportsList = data.data;
          })
          .finally(() => this.processando(false));
      }
    },
    solicitarExportacao(validar) {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = "É necessário informar o contribuinte!";
      } else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar o Preíodo Inicial!";
      } else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar o Preíodo Final!";
      } else if (!this.filtroSituacao && !this.filtroSituacao.key) {
        msg = "É necessário informar uma Situação!"
      } else if (!this.filtroTipo && !this.filtroTipo.key) {
        msg = "É necessário informar o Tipo de Exportação!";
      } else if(validar && (this.filtroTipo.key == "E" || this.filtroTipo.key == "P")){
        msg = "Exportações Gerais só podem ser feitas para o tipo XML!";
      }

      if (!msg) {
        this.$toast.add({
          group: "bc",
          severity: "info",
          summary: "Exportação em Andamento",
          detail:
            "A exportação foi iniciada e será processada em fila. Esse processo pode levar algumas horas para ser concluído, se houver grande volume de dados e à execução em rotina.",
          life: 15000,
        });

        this.processando(true);
        NotaFiscalService.solicitarExportacoNfse(
          this.currentUser.contribuinte.idContribuinte,
          this.currentUser.usuario.idUsuario,
          this.dataFatoGeradorIni,
          this.dataFatoGeradorFim,
          (this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : ""),
          (this.selectedServico && this.selectedServico.idServico ? this.selectedServico.idServico.idServicoItem : ""),
          (this.filtroSituacao && this.filtroSituacao.key != "T" ? this.filtroSituacao.key : ""),
          (this.filtroTipo && this.filtroTipo.key != "" && !validar ? this.filtroTipo.key : validar ? "G" : ""),
          (this.origem === "NFSE" ? "N" : "S")
        )
          .then(
            (data) => {
              this.$root.$emit("alert:success", "Exportação Solicitada com Sucesso!");
              console.log(data);
              this.consultaSolicitacoes();
            },
            (error) => {
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    downloadExportacao(idSolicitacao, tipo, dataIni, dataFim) {
      this.processando(true);
      if (tipo === "E" || tipo === "G" || tipo === "P") {
        ReportService.downloadExportacoesZip(
          idSolicitacao,
          this.$root,
          dataIni,
          dataFim
        ).then(
          (data) => {
            console.log(data);
          },
          (error) => {
            console.log(error);
          }
        ).then(() => {
          this.processando(false);
        });
      } else {
        ReportService.downloadExportacoesMaiorPer(
          idSolicitacao,
          this.$root
        ).then(
          (data) => {
            console.log(data);
          },
          (error) => {
            console.log(error);
          }
        ).then(() => {
          this.processando(false);
        });
      }
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
  },

  computed: {
    tituloModel(){
      return this.origem === 'NFSE' ? 'Exportar Notas Fiscais' : 'Exportar Substituição';
    },
    tiposFiltrados() {
      if (this.origem === 'DAPS') {
        return this.filtroTipos.filter(t => t.key === 'X');
      }
      return this.filtroTipos;
    },
    placeholderPessoa() {
      return this.origem === 'DAPS'
        ? 'Pesquisar CPF/CNPJ/Nome Prestador'
        : 'Pesquisar CPF/CNPJ/Nome Tomador';
    }
  }
};
</script>

<style scoped>
.msg-export {
  margin-top: 10px;
  text-align: left;
}

.container-button {
  width: 100%;
  display: flex;
  justify-content: space-between !important;
}

.container-button .box-button:first-child {
  display: flex;
}

.box-button {
  flex-direction: row;
}
</style>